import { jsxs as e, jsx as n } from "react/jsx-runtime";
import { E as p, S as f } from "./icons.types-0722eef5.js";
function d({ title: s, titleId: i, size: o, width: t, height: c, extended: l = !1, ...h }) {
  const r = l ? p : f, a = o ? r[o] : t || r[l ? "s" : "l"], w = o ? r[o] : c || r[l ? "s" : "l"];
  return /* @__PURE__ */ e(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 48 48",
      width: a,
      height: w,
      "aria-labelledby": i,
      ...h,
      children: [
        s ? /* @__PURE__ */ n("title", { id: i, children: s }) : null,
        /* @__PURE__ */ n(
          "path",
          {
            fill: "currentColor",
            d: "M24 14.4 9.6 28.8l1.68 1.68L24 17.76l12.72 12.72 1.68-1.68L24 14.4Z"
          }
        )
      ]
    }
  );
}
export {
  d as ArrowUp
};
